const INIT_STATE = {
   chatButtonNamePL: "",
   chatButtonNameEN: "",
   chatBtnVisible: false,
   isChatOpen: false,
   isChatMinimized: true,
   isChatDocked: false,
   fullScreenMode: false,
   currentRoomsListFolder: "Messages",
   currentRoom: {}
};

export default (state = INIT_STATE, action) => {
   switch (action.type) {
      case "SET_CHAT_SETTINGS":
         return {
            ...state,
            ...action.payload
         };
      case "SET_IS_CHAT_OPEN":
         return {
            ...state,
            isChatOpen: action.isChatOpen
         };
      case "SET_IS_CHAT_DOCKED":
         return {
            ...state,
            isChatDocked: !state.isChatDocked
         };
      case "SET_IS_CHAT_MINIMIZED":
         return {
            ...state,
            isChatMinimized: !state.isChatMinimized
         };
      case "SET_IS_CHAT_FULLSCREEN":
         return {
            ...state,
            fullScreenMode: action.fullScreenMode
         };
      case "SET_CURRENT_CHAT_ROOMS_FOLDER":
         return {
            ...state,
            currentRoomsListFolder: action.currentRoomsListFolder
         };

      default:
         return state;
   }
};
